import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { AddMembers } from "../AddMembers";

interface Props {
  open: boolean;
  setOpen: (val: boolean) => void;
  projectId: string;
}

export function InviteModal({ open, setOpen, projectId }: Props) {
  return (
    <Dialog
      open={open}
      onOpenChange={(open) => {
        setOpen(open);
      }}
    >
      <DialogContent className="bg-popover text-white p-0 max-w-[572px]">
        <div className="divide-y-2 flex flex-col py-4 max-w-[572px]">
          <DialogHeader className="px-8 py-2 pt-0">
            <DialogTitle className="text-sm font-bold text-gray-100">
              Share your work with others
            </DialogTitle>
          </DialogHeader>
          <AddMembers type="project" projectId={projectId} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
